// Func = limiting Scope for this file
var lastScrollTop = 0;
var url = window.location.hash;
var hash = url.substring(url.indexOf("#"));

(function () {
  // Loading bar
  document.onreadystatechange = function () {
    if (document.readyState === "complete") {
      //console.log(document.readyState);
      document.getElementById("PreLoaderBar").classList.add("complete");
      if (hash) {
        let targetSection = hash.split('#')[1];
        animateTo(targetSection);
      }
    }
  };

  //Click privacy policy
  if (hash == "#hover-image-491524") {
    $("a.item-491524").click();
  }
  if (hash == "#hover-image-491523") {
    $("a.item-491523").click();
  }

  //Anchors links
  $(function () {
    $(".cleanliness-badge-close").click(function (event) {
      $(".cleanliness-badge").addClass("close");

      event.preventDefault();
    });

    //pop in collapse header
    if (document.getElementById("popinCollapse")) {
      document
        .getElementById("popinCta")
        .addEventListener("click", function () {
          document.getElementById("popinCollapse").classList.add("open");
        });
      document
        .getElementById("popinContent")
        .addEventListener("click", function () {
          document.getElementById("popinCollapse").classList.remove("open");
        });

      $(".popin-cta").click(function () {
        ga("send", "event", "popup", "click", "40 Off Book Now");
      });
    }

    // Home footer fign up form functionality

	let footerSignUp = document.querySelector('.signup');
	let signUpCta = document.querySelector('.js-signup-cta');
	
	footerSignUp.style.cursor = 'pointer';
	footerSignUp.addEventListener('click', () => simulateClick(signUpCta));

	function simulateClick(elem) {
		const event = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        });
		elem.dispatchEvent(event);
	}

    /*MOBILE MENU NAV
     ****************************************************************/

    //Open Navigation
    $(".js-menu").click(function (event) {
      $("html").addClass("hide-overflow");
      $(".navigation").addClass("open");
      $(".navigation").stop().animate({ left: "0px" }, { duration: 300 });
      if ($(".navigation ul li a").hasClass(".item-open")) {
        $(".item-open").get(0).scrollIntoView(false);
      }
      event.preventDefault();
    });

    $(".close-menu").click(function (event) {
      event.preventDefault();
      $("html").removeClass("hide-overflow");
      $(".navigation").removeClass("open");
      $(".navigation")
        .stop()
        .animate({ left: "100%" }, { queue: false, duration: 300 });
    });

    $("#header .sub-menu").click(function () {
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
          $("html,body").animate(
            {
              scrollTop: target.offset().top - 200,
            },
            1000
          );
          $("#header .sub-menu ul > li > a").removeClass("active");
          $(this).addClass("active");
          return false;
        }
      }
    });
    // *only* if we have anchor on the urlQ
    $(document).on(
      "click",
      '.privary-navigation__item a[href^="#"]',
      function (event) {
        event.preventDefault();
        // smooth scroll to the anchor id
        $("html, body").animate(
          {
            scrollTop: $(window.location.hash).offset().top - 200,
          },
          2500
        );
      }
    );
  });

  $(document).ready(function () {
    // Wrap menus
    $(".primary-nav-1 .privary-navigation__item").wrapAll(
      "<div class='container d-flex pl-0'><div class='list-container'></div></div>"
    );
    $(".primary-nav-8 .privary-navigation__item").wrapAll(
      "<div class='container d-flex pl-0'><div class='list-container'></div></div>"
    );
    $(".primary-nav-13 .privary-navigation__item").wrapAll(
      "<div class='container d-flex pl-0'><div class='list-container'></div></div>"
    );
    $(".primary-nav-19 .privary-navigation__item").wrapAll(
      "<div class='container d-flex pl-0'><div class='list-container'></div></div>"
    );

    //Popin
    $(".btn-pop").click(function () {
      $(".info-pop").addClass("open");
    });

    $(".close-pop").click(function () {
      $(".info-pop").removeClass("open");
    });

    //booking show  js-booking-cta
    /*document.getElementsByClassName('js-booking-cta')[0].addEventListener('click', function (event) {
			if (!document.getElementsByClassName('booking-block')[0].classList.contains('open')) {
				document.getElementsByClassName('booking-block')[0].classList.add('open');
				this.classList.add('open');
				this.innerHTML = "Close";
				document.getElementById('header').classList.add('down');
				event.preventDefault();
			} else {
				document.getElementsByClassName('booking-block')[0].classList.remove('open');
				this.classList.remove('open');
				this.innerHTML = "Book Now";
				document.getElementById('header').classList.remove('down');
				event.preventDefault();
			}
		});*/

    setTimeout(function () {
      if ($(".topalert").length > 0) {
        $("body").addClass("withalert");
        $("header").css("top", "40px");
        $(".topalert").css("top", "0");
      }
    }, 600);
    $(".topalert__close").on("click", function () {
      $("header").css("top", "0");
      $(".topalert").css("top", "-50px");
    });

    var start = $("#arriveInput").attr("value");
    var end = $("#departureInput").attr("value");
    var firstClick = 0;

    var limitDate = $("#limitDate").attr("value").split(",");
    $("#datesCalendar").datepicker({
      minDate: start,
      numberOfMonths: 2,
      dateFormat: "mm/dd/yy",
      maxDate: new Date(limitDate[0], parseInt(limitDate[1]) - 1, 31),
      beforeShowDay: function (date) {
        setTimeout(function() {
          document.querySelectorAll('.ui-datepicker-calendar td a').forEach(e => {
            e.setAttribute('tabindex', '-1');
          })
        },1000);
        $.datepicker._defaults.dateFormat = "mm/dd/yy";
        var startDate = $.datepicker.parseDate("mm/dd/yy", start);
        var endDate = $.datepicker.parseDate("mm/dd/yy", end);

        if (date.getTime() == startDate.getTime()) {
          return [true, "start-day"];
        } else {
          if (date.getTime() == endDate.getTime()) {
            return [true, "end-day"];
          } else {
            if (
              date.getTime() > startDate.getTime() &&
              date.getTime() < endDate.getTime()
            ) {
              return [true, "days"];
            } else {
              return [true, ""];
            }
          }
        }
      },
      onSelect: function (date) {
        var selectedDate = $.datepicker.parseDate(
          $.datepicker._defaults.dateFormat,
          date
        );

        if (firstClick == 0) {
          start = date;
          end = date;
          firstClick = 1;
        } else {
          if (selectedDate <= start) {
            end = start;
            start = date;
          } else {
            end = date;
          }
          firstClick = 0;
        }

        $("#ArriveDay").attr("value", start);
        $("#DepartureDay").attr("value", end);

        $("#arriveInput").attr("value", start);
        $("#departureInput").attr("value", end);
      },
    });
    // Learn more button
    $(".js-learnmore").click(function (e) {
      var href = $(this).attr("href");
      if (!$(this).hasClass("active")) {
        $(this).html("Read Less");
        $(this).addClass("active");
        $(href).slideDown(500, "linear");
      } else {
        $(this).html("Read More");
        $(href).slideUp(500, "linear");
        $(this).removeClass("active");
      }
      e.preventDefault();
    });

    //Call function with browser is resized.
    $(window).resize(function (event) {
      //resizeWindow();
    });
    //resizeWindow();

    //Acts when scroll down page.
    // Submenu sticky

    // Submenu open
    $("#primary-nav li").hover(
      function () {
        //$(this).addClass("hover");
        $("ul.submenu", this).addClass("active");
        //$('header').addClass('down');
      },
      function () {
        $(this).removeClass("hover");
        $("ul.submenu", this).removeClass("active");
      }
    );

    //Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
    let DATE_STYLE = [true];
    function calendarRange(date) {
      let d1 = $.datepicker.parseDate(DATE_FORMAT, $("#CheckIn").val());
      let d2 = $.datepicker.parseDate(DATE_FORMAT, $("#CheckOut").val());
      if (
        (d1 && date.getTime() == d1.getTime()) ||
        (d2 && date.getTime() == d2.getTime())
      ) {
        DATE_STYLE[1] = "highlight-top";
      } else if (date > d1 && date < d2) {
        DATE_STYLE[1] = "highlight";
      } else {
        DATE_STYLE[1] = "";
      }
      return DATE_STYLE;
    }

    //Check in and check out datepicker for booking engine
    const DATE_FORMAT =
      $("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")
        ? $("#CheckIn").data("format")
        : "yy-mm-dd";
    $("#CheckIn").datepicker({
      //showOn: "both",
      //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
      //buttonImageOnly: true,
      changeMonth: true,
      dateFormat: DATE_FORMAT,
      numberOfMonths: 1,
      minDate: 0,
      beforeShowDay: (date) => calendarRange(date),
      onSelect: function (selectedDate) {
        let getDate = $(this).datepicker("getDate");
        let newDate = new Date(getDate.getTime());
        newDate.setDate(newDate.getDate() + 3);
        $("#CheckOut").datepicker("setDate", newDate);
        $("#CheckOut").datepicker("option", "minDate", selectedDate);
      },
    });
    $("#CheckOut").datepicker({
      //showOn: "both",
      //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
      //buttonImageOnly: true,
      dateFormat: DATE_FORMAT,
      changeMonth: true,
      numberOfMonths: 1,
      beforeShowDay: (date) => calendarRange(date),
      onSelect: function (selectedDate) {
        //$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
      },
    });

    // Map: Return to previous page button. Change body id to match map template's name.
    //$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

    // Hover elements
    $(".js-h-item").hover(function (e) {
      //$('html, body').animate({ scrollTop: $('.hover-items__container').offset().top-200 }, 'slow');
      e.preventDefault();
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
      var href = $(this).attr("data-target");
      $(href).addClass("active");
      $(href).siblings().removeClass("active");
      if (!$(this).hasClass("js-menu")) {
        e.preventDefault();
      }
    });

    $(".our-rooms__titles--item").hover(function (e) {
      console.log($(this).attr("data-target"));
      e.preventDefault();
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
      var href = $(this).attr("data-target");
      $(href).addClass("active");
      $(href).siblings().removeClass("active");
    });

    $(".amenities").on("click", function (e) {
      $(".item-491517").trigger("click");
      e.preventDefault();
    });

   

    //Hover btn stay pass
    $("#btn-the-stanford-park-stay-pass").on("mouseenter", function () {
      $(this).html("650-322-1234");
    });
    $("#btn-the-stanford-park-stay-pass").on("mouseleave", function () {
      $(this).html("Call to Book");
    });

    //Slick JS
    //Carousel
    $(".carousel__container--slider").slick({
      centerMode: true,
      centerPadding: "0px",
      infinite: true,
      slidesToShow: 3,
      initialSlide: 1,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $(".carousel__container-fluid").slick({
      infinite: true,
      centerMode: true,
      centerPadding: "15%",
      slidesToShow: 1,
    });

    $(".reviews-slider").slick({
      arrows: true,
      infinite: true,
      slidesToShow: 1,
      autoplay: true,
      autoplaySpeed: 6000,
      slidesToScroll: 1,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      fade: true,
    });

    $(".press-slider").slick({
      centerMode: true,
      centerPadding: "0px",
      dots: false,
      infinite: true,
      accessibility: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      fade: false,
      appendArrows: ".arrows-holder",
      initialSlide: 1,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            centerMode: false,
            centerPadding: "0px",
            slidesToShow: 2,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 641,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 3,
          },
        },
      ],
    });

    $(".our-rooms-block-slider").slick({
      dots: true,
      arrow: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      centerPadding: "20px",
      infinite: true,
      centerMode: true,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            autoplaySpeed: 4000,
            slidesToShow: 1,
          },
        },
      ],
    });

    // slick hover
    $(".slick-slider").mousemove(function (e) {
      if (e.pageX - this.offsetLeft < $(this).width() / 1.5) {
        $(this).remove("hover-right");
        $(this).addClass("hover-left");
      } else {
        $(this).removeClass("hover-left");
        $(this).addClass("hover-right");
      }
    });
    $(".slick-slider").on("click", function (e) {
      if (e.pageX - this.offsetLeft < $(this).width() / 1.5) {
        $(this).slick("slickPrev");
      } else {
        $(this).slick("slickNext");
      }
    });
    $(".slick-slider").mouseout(function () {
      $(this).removeClass("hover-right");
      $(this).removeClass("hover-left");
    });

    // Custom Select
    $("select").each(function () {
      var $this = $(this),
        numberOfOptions = $(this).children("option").length;

      $this.addClass("select-hidden");
      $this.wrap('<div class="select"></div>');
      $this.after('<div class="select-styled"></div>');

      var $styledSelect = $this.next("div.select-styled");
      $styledSelect.text($this.children("option").eq(0).text());

      var $list = $("<ul />", {
        class: "select-options",
      }).insertAfter($styledSelect);

      for (var i = 0; i < numberOfOptions; i++) {
        $("<li />", {
          text: $this.children("option").eq(i).text(),
          rel: $this.children("option").eq(i).val(),
        }).appendTo($list);
      }

      var $listItems = $list.children("li");

      $styledSelect.click(function (e) {
        e.stopPropagation();
        $("div.select-styled.active")
          .not(this)
          .each(function () {
            $(this).removeClass("active").next("ul.select-options").hide();
          });
        $(this).toggleClass("active").next("ul.select-options").toggle();
      });

      $listItems.click(function (e) {
        e.stopPropagation();
        $styledSelect.text($(this).text()).removeClass("active");
        $this.val($(this).attr("rel"));
        $list.hide();
        //console.log($this.val());
      });

      $(document).click(function () {
        $styledSelect.removeClass("active");
        $list.hide();
      });
    });
    //Fancybox
    $(".fancybox-donation").fancybox({
      // options for images here
      wrapCSS: "fancybox-donation",
    });

    $(".more-info-btn").fancybox({
      wrapCSS: "fancybox-meetings",
    });

    $(".btn-chart").fancybox({
      wrapCSS: "fancybox-chart",
    });

    $(".fancybox-woodside").fancybox({
      wrapCSS: "fancybox-meetings fancybox-woodside",
    });

    $(".js-signup__btn").fancybox({
      wrapCSS: "signup-overlay",
    });

    $(".js-menus").fancybox({
      wrapCSS: "menus-overlay",
    });

    $(".fancybox-header").fancybox({
      // options for images here
      wrapCSS: "fancybox-header",
    });
  });

  window.addEventListener("load", function () {
    var scroll = $(window).scrollTop();
    if (scroll >= 50) {
      $(".header").addClass("down");
    }

    //no removing needed cause refresh did it
  });

  window.onload = function () {
    /*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

    //scrollW();
    window.addEventListener("scroll", function () {
      //scrollW();

      $(window).scroll(function () {
        var scrollTop = $(document).scrollTop();
        var anchors = $("body").find("section");

        for (var i = 0; i < anchors.length; i++) {
          if (
            scrollTop > $(anchors[i]).offset().top - 50 &&
            scrollTop < $(anchors[i]).offset().top + $(anchors[i]).height() - 50
          ) {
            $(
              '#header .sub-menu ul > li > a[href="#' +
                $(anchors[i]).attr("data-section") +
                '"]'
            ).addClass("active");
          } else {
            $(
              '#header .sub-menu ul > li > a[href="#' +
                $(anchors[i]).attr("data-section") +
                '"]'
            ).removeClass("active");
          }
        }
      });
      scroll();
    });
  };
})();

//single form function
function Gratitude() {
  document.getElementsByClassName("text-top")[0].classList.add("submitted");
}

function scroll() {
  if ($(this).scrollTop() > 559) {
    $("#header .sub-menu").addClass("sticky");
  } else {
    $("#header .sub-menu").removeClass("sticky");
  }
  if ($(window).scrollTop() > 50) {
    $(".header").addClass("down");
  } else {
    //remove the background property so it comes transparent again (defined in your css)
    $(".header").removeClass("down");
  }
  if (document.body.classList.contains("home")) {
    if ($(window).scrollTop() > 200) {
      $("#header-aside").removeClass("no-show");
    } else {
      $("#header-aside").addClass("no-show");
    }
  }
}

// Set email value from footer to sigunp popup
let valueEmail = document.getElementById("f-signup-button");
let signupEmail = document.getElementById("email-signup_email_address");
let valueEmail_contact = document.getElementById("signup-contact");

// valueEmail.addEventListener('change', function () {
// 	signupEmail.value = valueEmail.value;
// })

// Add body class singup-overlay button
let btnSign = document.getElementById("f-signup");
let body = document.getElementsByTagName("body")[0];
// btnSign.addEventListener("click", function () {
//   body.classList.add("signup-overlay");
// });
let btnSignHeader = document.getElementById("f-signup-header");
btnSignHeader.addEventListener("click", function () {
  body.classList.add("signup-overlay");
});

if (document.body.className.match("contact-directions")) {
  let btnSignC = document.getElementById("js-signup__btn");
  btnSignC.addEventListener("click", function () {
    body.classList.add("signup-overlay");
  });
  valueEmail_contact.addEventListener("change", function () {
    signupEmail.value = valueEmail_contact.value;
  });
}

//Slick mobile - Hover images
// $('.policies .hover-items__titles').slick('unslick');
// $('.policies .hover-items__images').slick('unslick');

// $('.booking-benefits .hover-items__titles').slick('unslick');
// $('.booking-benefits .hover-items__images').slick('unslick');

$(".hover-items__images").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  mobileFirst: true,
  asNavFor: ".hover-items__titles--cont",
  mobileFirst: true,
  responsive: [
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1200,
      settings: "unslick",
    },
  ],
});
//Slick mobile - Hover Images
$(".hover-items__titles--cont").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  mobileFirst: true,
  arrows: false,
  slide: ".hover-items__titles--item",
  asNavFor: ".hover-items__images",
  mobileFirst: true,
  responsive: [
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
      },
    },
    {
      breakpoint: 1200,
      settings: "unslick",
    },
  ],
});
//Slick mobile - Our rooms
$(".our-rooms__images").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  mobileFirst: true,
  infinite: true,
  asNavFor: ".our-rooms__titles--holder",
  mobileFirst: true,
  responsive: [
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1200,
      settings: "unslick",
    },
  ],
});
//Slick mobile - Our Rooms
$(".our-rooms__titles--holder").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  mobileFirst: true,
  infinite: true,
  asNavFor: ".our-rooms__images",
  arrows: false,
  mobileFirst: true,
  responsive: [
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1200,
      settings: "unslick",
    },
  ],
});
